export default __webpack_public_path__ + "static/media/solsheeppromo.473ab1be.mp4";